import Box from "@mui/material/Box";

// Centered, readable-width block used for the marketing page sections.
export const Section = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        my: 12,
        textAlign: "left",
        maxWidth: "40em",
        mx: "auto",
        px: 0,
      }}
      className={"section"}
    >
      {children}
    </Box>
  );
};
